import React from "react";
import { Link } from "react-router-dom";

export default function SupportContactBox(props) {
  return (
    <div className="col-lg support-contact-details-card">
      <h5 className="mb-2 fw-semibold">{props.title}</h5>
      <p className="mb-2 py-1">{props.text}</p>
      <p className="p-0 m-0 mt-3">
        <Link to={`/form/${props.link}`} className="text-decoration-none custom-anchor">
          {props.linkText}
        </Link>
      </p>
    </div>
  );
}
